import { Oraculo } from "@core/oraculo";
import style from "@styles/pages/cdp/cdp-base-node.module.scss";
import React from "react";

const formatRelativeFilter = ({ max, min, type, period }) => {
  const periods = {
    day: "dia(s)",
    month: "mês(es)",
    year: "ano(s)",
  };

  const unidade = periods[period] || period;

  if (type === "in_last") {
    return `Nos últimos ${min} ${unidade}`;
  }

  if (type === "more_than") {
    return `Há mais de ${min} ${unidade}`;
  }

  return "";
};

const formatDateRangeFilter = ({ min, max, period }) => {
  const parseDate = (str) => {
    const [day, month, year] = str.split("/");
    return new Date(`${year}-${month}-${day}`);
  };

  const formatDate = (str) => {
    const date = parseDate(str);
    return date.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  return `Entre ${formatDate(min)} e ${formatDate(max)}`;
};

export const Clause = ({ clause, onClick }) => {
  const edit = (event) => {
    if (onClick) {
      return onClick(event, {
        action: "edit",
        target: clause.id,
      });
    }
  };

  return (
    <div className={style.condition}>
      <div className="d-flex align-center justify-between">
        <OperandChip
          type={clause.type}
          operand={clause.operand}
          data={clause}
        />
        <div className={style.edit} onClick={edit}>
          <i className="fal fa-info-circle" />
        </div>
      </div>

      {!clause?.range?.type && clause?.range?.period && (
        <div className={style.date}>
          <span>Todo o período</span>
        </div>
      )}
      {["in_last", "more_than"].includes(clause?.range?.type) && (
        <div className={style.date}>
          <span>{formatRelativeFilter(clause?.range)}</span>
        </div>
      )}
      {clause?.range?.type === "range" && (
        <div className={style.date}>
          <span>{formatDateRangeFilter(clause?.range)}</span>
        </div>
      )}
    </div>
  );
};

const OperandChip = ({ type, operand, data }) => {
  const { label, value, range } = data;
  const text = Oraculo.operandLabel(type, operand, { value, range });
  const _value = Oraculo.formatValue(type, operand, { label, value, range });

  return (
    <div className={style.name}>
      <span>{text}&nbsp;&nbsp;-&nbsp;&nbsp;</span>
      <strong>{_value}</strong>
    </div>
  );
};
